 'use strict';
(function () {
    angular
        .module('bidding')
        .component('biddingDetailsComponent', {
            templateUrl: 'bidding/components/bidding-details-component.tpl.html',
            controller: function (EventManagerService,MessageService,PopupManager,ContextMenuService, BiddingService,BiddingFactory, $timeout, $window, BiddingSelectionHelper , StorageServices, CrewingHelper , TabService) {
            	 var vm = this;

            	 vm.timeLineData = null;
            	 vm.crewBiddingData = null;
            	 vm.cycleInfo = null;
            	 vm.viewType = 'M';
            	 vm.scrollAreaWidth = 0;

            	 vm.screen_left_panel = 330;
            	 var min_screen_width = 1200;
            	 var numberOfDaysInWeek = 10;

            	 vm.numberOfDatesInCycle = 0;
            	 vm.screen_right_panel = 0;
            	 vm.actual_screen_width = 0;
            	 vm.blockWidth = 100;

            	 vm.selectedCrewBiddingRequest = null;
            	 vm.selectedCrewBiddingInfo = null;
            	 vm.responsive_right_section_width = $window.innerWidth - (vm.screen_left_panel + 11);

            	 vm.approveLaterBidsCollection = [];

            	 vm.selectedCrewtobeLoad = null;

            	 EventManagerService.registerEventListener(EventManagerService.EVENT.CREW_BIDDING.CLEAR_BOTTOM_LINE,resetBottomTimeline);

            	 EventManagerService.registerEventListener(EventManagerService.EVENT.CREW_BIDDING.DRAW_TIME_LINES, drawTimeLines);

            	 EventManagerService.registerEventListener(EventManagerService.EVENT.CREW_BIDDING.DRAW_BIDDING_INFO, drawBiddingInformation);

            	 EventManagerService.registerEventListener(EventManagerService.EVENT.CREW_BIDDING.REMOVE_SELECTED_BID, removeSelectedBid);

            	 EventManagerService.registerEventListener(EventManagerService.EVENT.CREW_BIDDING.APPROVE_SELECTED_BID, approveSelectedCrewBids);

            	 EventManagerService.registerEventListener(EventManagerService.EVENT.CREW_BIDDING.CANCEL_APPROVE_PROCESS, cancelApprove);

            	 EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.CREW_SCHEDULE, loadCrewSchedule);

            	 EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.BIDDING_APPROVE_ALL, approveSelectedCrewBids);

            	 EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.BIDDING_DELETE_ALL, onClickDeleteAll);

            	 EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.BIDDING_APPROVE_PATTERN, approveSelectedCrewPatternBids);

            	 EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.BIDDING_APPROVE_EVENT, approveSelectedEventCrewBids);

            	 angular.element($window).bind('resize',function(){
                 	vm.responsive_right_section_width = window.innerWidth - (vm.screen_left_panel + 66);
                 });

            	 vm.cancelApprove = function(isTimelineOpen){
            		 vm.approveLaterBidsCollection = [];
            		 EventManagerService.notifyEventListeners(EventManagerService.EVENT.CREW_BIDDING.RESET_SEARCH_RESULT);
            		 updateSelectedCrewBidsTimeline(isTimelineOpen);
            		 EventManagerService.notifyEventListeners(EventManagerService.EVENT.RESET_BOTTOM_LINE_OPENED_FLAG,isTimelineOpen);
            	 }

            	 vm.onClickCrewBidding = function(event,biddingRequest,crewInfo){
            		 if(biddingRequest.approved) {
            			 /*biddingRequest.popOverFlag = true;
                		 vm.selectedCrewBiddingRequest =  biddingRequest;
                		 vm.selectedCrewBiddingInfo = crewInfo;*/
            			 return;
            		 }
            		 var context = {
            				 block: biddingRequest,
                             crews: crewInfo,
                         };
            		 if (event.shiftKey) {
            			 BiddingSelectionHelper.performAction(BiddingSelectionHelper.ELEMENT_NAMES.BLOCK, BiddingSelectionHelper.INTERACTION.SHIFT_CLICK, context);
                     } else if (event.ctrlKey) {
                    	 BiddingSelectionHelper.performAction(BiddingSelectionHelper.ELEMENT_NAMES.BLOCK, BiddingSelectionHelper.INTERACTION.CTRL_CLICK, context);
                     } else {
                    	 BiddingSelectionHelper.performAction(BiddingSelectionHelper.ELEMENT_NAMES.BLOCK, BiddingSelectionHelper.INTERACTION.CLICK, context);
                     }
            	 }

            	 vm.onClickCrewName = function(event,crewBidding){
            		 var context = {
                             crews: crewBidding,
                         };
            		 if (!!event && event.ctrlKey) {
                    	 BiddingSelectionHelper.performAction(BiddingSelectionHelper.ELEMENT_NAMES.CREW, BiddingSelectionHelper.INTERACTION.CTRL_CLICK, context);
                     } else {
                    	 BiddingSelectionHelper.performAction(BiddingSelectionHelper.ELEMENT_NAMES.CREW, BiddingSelectionHelper.INTERACTION.CLICK, context);
                     }
            	 }

            	 vm.onBiddingRightClick = function(clickedScope) {
            		 if(vm.selectedCrewBiddingRequest != null) {
            			 vm.selectedCrewBiddingRequest.popOverFlag = false;
            		 }
            		 if(clickedScope.biddingRequest.approved) {
                		 vm.selectedCrewBiddingRequest =  clickedScope.biddingRequest;
                		 vm.selectedCrewBiddingRequest.popOverFlag = true;
                		 //vm.selectedCrewBiddingInfo = crewInfo;
                		 return;
            		 }
            		 var context = {
            				 block: clickedScope.biddingRequest,
                             crews: clickedScope.$parent.crewBidding,
                     };
            		 BiddingSelectionHelper.performAction(BiddingSelectionHelper.ELEMENT_NAMES.BLOCK, BiddingSelectionHelper.INTERACTION.RIGHT_CLICK, context);
            		 var blocks = BiddingSelectionHelper.getSelectedBlocks();
            		 vm.selectedCrewBiddingRequest = clickedScope.biddingRequest;
            		 vm.selectedCrewBiddingRequest.popOverFlag = true;
            		 vm.selectedCrewBiddingRequest.displayBiddingDate = BiddingSelectionHelper.getFirstBlock(blocks).biddingDate + " to " +
            		 	BiddingSelectionHelper.getLastBlock(blocks).biddingDate;

            		 if(blocks.length >= 2) {
            			 vm.selectedCrewBiddingRequest.multiSelect = true;
            		 } else{
            			 vm.selectedCrewBiddingRequest.multiSelect = false
            			 vm.selectedCrewBiddingRequest.isExactPattern = blocks[0].isExactPattern;
            		 }
            	 }

            	 vm.onClickDelete = function() {
            		 populateBidCollectionForApproveOrDelete(false);
            		 vm.deleteSelectedCrewBids();
            		 BiddingSelectionHelper.cancelPreviousSelections();
            	 }

            	 vm.clickOnApprove = function() {
            		 populateBidCollectionForApproveOrDelete(true);
            		 vm.approveSelectedCrewBids();
            		 BiddingSelectionHelper.cancelPreviousSelections();
            	 }

            	 function populateBidCollectionForApproveOrDelete(isForApprove) {
                 if(!!vm.selectedCrewBiddingRequest) {
                   vm.selectedCrewBiddingRequest.popOverFlag = false;
                 }
            		 vm.approveLaterBidsCollection = [];
            		 var blocks = BiddingSelectionHelper.getSelectedBlocks();
            		 angular.forEach(blocks, function(block) {
            			if( block.isExactPattern || (!block.isExactPattern && !isForApprove)) {
            				vm.selectedCrewBiddingRequest =  block;
                    		vm.selectedCrewBiddingInfo = _.find(vm.crewBiddingData, {crewProfId: block.crewProfId});
                			vm.approveLaterBidsCollection = BiddingFactory.populateSelectedCrewBiddingList(vm.approveLaterBidsCollection,
                    				 vm.selectedCrewBiddingInfo,vm.selectedCrewBiddingRequest);
            			}
            		 });
            	 }


            	 vm.onClickAddToApprove = function() {
            		 vm.selectedCrewBiddingRequest.popOverFlag = false;
            		 vm.selectedCrewBiddingRequest.userSelectedToApprove = true;
            		 vm.approveLaterBidsCollection = BiddingFactory.populateSelectedCrewBiddingList(vm.approveLaterBidsCollection,
            				 vm.selectedCrewBiddingInfo,vm.selectedCrewBiddingRequest);
            		 updateSelectedCrewBidsTimeline(true);
            		 EventManagerService.notifyEventListeners(EventManagerService.EVENT.RESET_BOTTOM_LINE_OPENED_FLAG,true);
            	 }

            	 vm.onClickDirectApprove = function() {
            		 vm.selectedCrewBiddingRequest.popOverFlag = false;
            		 removeSelectedBid(vm.selectedCrewBiddingRequest);
            		 updateSelectedCrewBidsTimeline(false);

            		 var params = {
            				 crewInfo :  vm.selectedCrewBiddingInfo,
            				 bidInfo :  vm.selectedCrewBiddingRequest
            		 }

            		 BiddingService.directApproveBidding(
            				 params,
            				 function(response){
            					 populateAssignResponseViewData(response);
            				 },
            				 function(error){
            					 MessageService.error(error);
            				 }
            		);
            	 }


            	 vm.approveSelectedCrewBids = function( approvalType){
            		 if( vm.approveLaterBidsCollection == null ||  vm.approveLaterBidsCollection.length == 0){
            			 MessageService.error('Please select at least one crew bid request to proceed.');
            			 return;
            		 }

                     BiddingService.approveBidCollection(vm.approveLaterBidsCollection, approvalType,
                    	function(response){
                    	 	 populateAssignResponseViewData(response);
                     	},
                     	function(error){
                     		MessageService.error(error);
                     	}
                     );
            	 }

            	 vm.deleteSelectedCrewBids = function(){
            		 if( vm.approveLaterBidsCollection == null ||  vm.approveLaterBidsCollection.length == 0){
            			 MessageService.error('Please select at least one crew bid request to proceed.');
            			 return;
            		 }

                     BiddingService.deleteBidCollection(vm.approveLaterBidsCollection,
                    	function(response){
                    	 	 populateAssignResponseViewData(response, true);
                     	},
                     	function(error){
                     		MessageService.error(error);
                     	}
                     );
            	 }

              vm.getContextMenu = function(clickedScope ,event,crewBidding) {
                // vm.onClickCrewName(event,crewBidding);
                populateBidCollectionForApproveOrDelete(true);
                vm.selectedCrewtobeLoad =  crewBidding.crewId;
                if( !(vm.approveLaterBidsCollection == null &&  vm.approveLaterBidsCollection.length == 0) && !isRightClickOnSelectedCrew()){
                  vm.onClickCrewName(event,crewBidding);
                  populateBidCollectionForApproveOrDelete(true);
                }

                if( vm.approveLaterBidsCollection == null ||  vm.approveLaterBidsCollection.length == 0){
                  // MessageService.error('Please select at least one crew bid request to proceed.');
                  return ContextMenuService.getContextMenu('BIDDING_CREW_ONLY');
                }else if( vm.approveLaterBidsCollection == null ||  vm.approveLaterBidsCollection.length == 1){
                  return ContextMenuService.getContextMenu('BIDDING_CREW');
                }else {
                  return ContextMenuService.getContextMenu('BIDDING_ONLY');
                }
              }


              vm.onShowCrewSchedule = function (params) {
                var crew = params[0];
                vm.crewList = crew.crewId;
                var tabName = 'crewSchedule';
                StorageServices.setTabData(tabName, 'crewingParams', {
                  crewId: vm.selectedCrewtobeLoad,
                  fromDate: vm.cycleInfo.dateFrom,
                  toDate: vm.cycleInfo.dateTo,
                  fleetExperince: null,
                  crewBase: null,
                  crewIdCol : CrewingHelper.getCrewIds(crew.crewId)
                });
                TabService.gotoTab(tabName, {
                  crewId: vm.selectedCrewtobeLoad
                });
              };

              vm.onDoubleClickCrewNameHeader = function(event,crewBidding){
                  angular.forEach(vm.crewBiddingData, function (biddingData) {
                    var context = {
                      crews: biddingData,
                    };
                    BiddingSelectionHelper.performAction(BiddingSelectionHelper.ELEMENT_NAMES.CREW, BiddingSelectionHelper.INTERACTION.CTRL_CLICK, context);
                  });
              }

            	 function cancelApprove(isTimelineOpen){
            		 vm.cancelApprove(isTimelineOpen);
            	 }

            	 function loadCrewSchedule() {
            	   vm.onShowCrewSchedule('test');

               }
            	 function approveSelectedCrewBids(){
            		 vm.approveSelectedCrewBids('ALL');
            	 }
              function approveSelectedCrewPatternBids(){
                vm.approveSelectedCrewBids('PATTERN');
              }
              function approveSelectedEventCrewBids(){
                vm.approveSelectedCrewBids('OFF');
              }

            	 function resetBottomTimeline(){
            		 vm.approveLaterBidsCollection = [];
            		 updateSelectedCrewBidsTimeline(false);
            	 }

            	 function drawTimeLines(viewData){
            		 vm.cycleInfo = viewData.cycleInfo;
            		 vm.viewType = viewData.viewType;
                     renderTimeLine();
                     renderSelectedCrewBidsTimeline();
            	 }

            	 function drawBiddingInformation(crewBiddingData){
            		 vm.crewBiddingData = crewBiddingData;
            		 BiddingSelectionHelper.setCrewBiddingData(crewBiddingData);
            	 }

            	 function populateAssignResponseViewData(response, isForDelete){

            		 if(response != null && response.biddingCrewResponseCollection != null &&
            				 response.biddingCrewResponseCollection.length > 0){
            			 PopupManager.openModal('BIDDING_ERROR_POPUP', response , onPopUpClose);
            		 } else if(isForDelete){
            			 var successMsg = "Successfully deleted selected crew bid requests.";
            			 MessageService.success(successMsg);
            			 onPopUpClose();
            		 } else{
            			 var successMsg = "Successfully approved all crew bid requests.";
            			 MessageService.success(successMsg);
            			 onPopUpClose();
            		 }

            	 }

            	 function onPopUpClose(){
            		 EventManagerService.notifyEventListeners(EventManagerService.EVENT.CREW_BIDDING.CLEAR_BOTTOM_LINE);
            		 EventManagerService.notifyEventListeners(EventManagerService.EVENT.CREW_BIDDING.SEARCH_BIDDING_WITH_SEARCH_OPTIONS);
            		 EventManagerService.notifyEventListeners(EventManagerService.EVENT.RESET_BOTTOM_LINE_OPENED_FLAG,false);
            	 }

            	 function removeSelectedBid(crewBidDel){
            		 EventManagerService.notifyEventListeners(EventManagerService.EVENT.CREW_BIDDING.RESET_SELECTED_CREW_BID,crewBidDel);
            		 vm.approveLaterBidsCollection = BiddingFactory.removeSelectedCrewBid(vm.approveLaterBidsCollection,crewBidDel);

            		 var showTimeLine = false;
            		 if(vm.approveLaterBidsCollection != null && vm.approveLaterBidsCollection.length>0){
            			 showTimeLine = true;
            		 }

            		 updateSelectedCrewBidsTimeline(showTimeLine);
            	 }

            	 function updateSelectedCrewBidsTimeline(showTimeline){

            		 var viewData = {
            				 selectedBiddings : vm.approveLaterBidsCollection,
         					 showTimeline : showTimeline
         			  };

            		 EventManagerService.notifyEventListeners(EventManagerService.EVENT.CREW_BIDDING.UPDATE_BOTTOM_LINE_DATA,viewData);
            		 EventManagerService.notifyEventListeners(EventManagerService.EVENT.RESET_BOTTOM_LINE_OPENED_FLAG,showTimeline);
            	 }

            	 function renderSelectedCrewBidsTimeline(){

         			 var viewData = {timeLineData : vm.timeLineData,
         					 viewType :vm.viewType ,
         					 screen_left_panel : vm.screen_left_panel ,
         					 numberOfDatesInCycle : vm.numberOfDatesInCycle ,
         					 blockWidth : vm.blockWidth
         			  };
            		 EventManagerService.notifyEventListeners(EventManagerService.EVENT.CREW_BIDDING.DRAW_BOTTOM_LINE,viewData);
         		 }

            	 function renderTimeLine(){
            		 populateBlockSizes();
            		 populateHeaderData();
            		 populateNumberOfDaysInCycle();
            	 }

            	 function populateBlockSizes(){

            		 vm.actual_screen_width = window.innerWidth;

            		 if (!!vm.actual_screen_width && vm.actual_screen_width > min_screen_width) {
                         vm.screen_right_panel = vm.actual_screen_width - vm.screen_left_panel;
                     }else{
                    	 vm.screen_right_panel = min_screen_width;
                     }

            		 if(vm.viewType == 'M'){
            		   var updatedSreenRightPanelSize=vm.numberOfDatesInCycle+0.5;
            			 vm.blockWidth = Math.floor( ( vm.screen_right_panel /updatedSreenRightPanelSize) );
            		 }else{
            			 vm.blockWidth = Math.floor( ( vm.screen_right_panel / numberOfDaysInWeek ) );
            		 }

            	 }

            	 function populateNumberOfDaysInCycle(){
            		 var fromDate = vm.cycleInfo.dateFrom;
            		 var toDate = vm.cycleInfo.dateTo;
            		 var startDate = moment( fromDate , 'DD/MM/YYYY');
            		 var endDate = moment( toDate, 'DD/MM/YYYY');
            		 vm.numberOfDatesInCycle =  endDate.diff(startDate, 'days')  + 1;
            	 }

            	 function populateHeaderData() {
            		 var fromDate = vm.cycleInfo.dateFrom;
            		 var toDate = vm.cycleInfo.dateTo;
            		 var mo_fromDate = moment(fromDate, 'DD/MM/YYYY');
            		 var mo_toDate = moment(toDate, 'DD/MM/YYYY');
            		 vm.scrollAreaWidth = vm.blockWidth;
            		 vm.timeLineData = [];
            		 var isFirst = true;

            		 while(mo_fromDate < mo_toDate){

            		   if(isFirst){
            			   vm.timeLineData.push(renderTimelineHeader(mo_fromDate));
            			   isFirst = false;
            		   }

          		       var newDate = moment(mo_fromDate).add(1, 'day');
          		       vm.timeLineData.push(renderTimelineHeader(newDate));
          		       mo_fromDate = newDate;
          		       vm.scrollAreaWidth += vm.blockWidth;
           		     }
            	 }

              vm.onBlockHover = function (e, block) {
                vm.blockToolTiop = block;
                var findCheckPosition = function () {
                  var H = 'left', V = 'top';
                  if ((e.clientX + e.target.offsetWidth + 100) > vm.screen_right_panel) {
                    H = 'left';
                  } else {
                    H = 'right';
                  }
                  if ((e.clientY + e.target.offsetHeight + 100) > vm.comHeight) {
                    V = 'bottom';
                  } else {
                    V = 'top';
                  }
                  return H + '-' + V;
                };

                vm.toolTipPosition = findCheckPosition();
              };

              function renderTimelineHeader(mo_date) {
                var firstDayOfCycle = mo_date.format('ddd');
                var firstDateOfCycle = mo_date.format('D');
                var monthOfCycle = mo_date.format("MMM");

                var values = ["1st", "2nd", "3rd", "4th", "5th", "6th", "7th", "8th", "9th", "10th", "11th", "12th",
                              "13rd", "14th", "15th", "16th", "17th", "18th", "19th", "20th", "21th", "22nd", "23rd",
                              "24th", "25th", "26th", "27th", "28th", "29th", "30th", "31st"];
                var ordinalValue = values[firstDateOfCycle - 1];

                return (firstDayOfCycle + ' ' + ordinalValue + ' ' + monthOfCycle );
            	 }

            	 function isRightClickOnSelectedCrew() {
            	   var crewIdFound = false;
                  angular.forEach(vm.approveLaterBidsCollection ,function (val,key) {
                    if(val.crewId == vm.selectedCrewtobeLoad){
                      crewIdFound =  true;
                    }
                  })
                  return crewIdFound;

               }

              function onClickDeleteAll(){
                vm.onClickDelete();
              }


            },
            bindings: {

            }
        })
})();

